import React, { useState, useRef, useEffect, useContext } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import UserContext from '../../config/UserContext'
import {
  HttpService,
  swal,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  Button,
  Modal,
  Spinner
} from '../../config/react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

const AddProductAttributeSet = () => {
  const urlParams = useParams()
  const history = useHistory()
  const validator = useRef(new SimpleReactValidator())
  const groupvalidator = useRef(new SimpleReactValidator())
  const user = useContext(UserContext)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [ShowGroupModal, setShowGroupModal] = useState(false)
  const [GroupModalTitle, setGroupModalTitle] = useState(Title.AddAttributeGroup)
  const [IsDuplicateGroup, setIsDuplicateGroup] = useState('')
  const defaultPlus = 'mdi mdi-plus-box menu-icon fs-16'
  const defaultminus = 'mdi mdi-minus-box menu-icon fs-16'
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const [AttrSetItems] = useState({
    items: [],
    groups: []
  })
  const [Inputs] = useState({
    id: 0,
    name: '',
    status: 1
  })
  const [GroupInputs] = useState({
    name: '',
    id: 0
  })
  const grid = 8

  const id2List = {
    droppable: 'items',
    droppable2: 'selected'
  }

  useEffect(() => {
    setIsAuth(true)
    setLoading(false)
    document.title = Title.AddProductAttributeSet
    document.body.style.overflow = 'hidden'
    if (urlParams.id !== undefined) {
      document.title = Title.EditProductAttributeSet
      GetProductAttributeSetDetail()
      AttrSetItems.groups = []
    } else {
      GetProductAttributeList()
      AttrSetItems.groups = [
        {
          id: 0,
          content: 'Default Group',
          className: 'lableNone',
          selected: []
        }
      ]
    }
  }, [urlParams.id])

  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value

    if (
      field === 'status' ||
      field === 'is_required' ||
      field === 'use_in_search' ||
      field === 'show_in_storefront'
    )
      Inputs[field] = e.target.checked
    else Inputs[field] = fieldval
    setForceUpdate(!isForceUpdate)
  }

  const handleGroupInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value
    GroupInputs[field] = fieldval
    setForceUpdate(!isForceUpdate)
  }

  const GetProductAttributeSetDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeSetDetail, param).then((response) => {
      setLoading(false)
      if (response.data.result[0]) {
        const data = response.data.result[0]
        const param = {
          limit: 10,
          page: 1
        }
        const ArrayItem = []
        setLoading(true)
        HttpService.postApi(API.GetProductAttributeList, param).then((response) => {
          setLoading(false)
          response.data.result[0].map(function (k, v) {
            ArrayItem.push({ id: k.attribute_code, content: k.attribute_name })
            return true
          })
          AttrSetItems.items = ArrayItem
          data.map((item) =>
            Object.keys(item).map(function (key, value) {
              if (key === 'group_names' || key === 'attributes' || key === 'group_id') {
                if (key === 'group_id' && item.group_id !== '') {
                  const groupIds = item.group_id.split(', ')
                  const unique = groupIds.filter((v, i, a) => a.indexOf(v) === i)
                  const groupNames = item.group_names.split(', ')
                  const uniqueNames = groupNames.filter((v, i, a) => a.indexOf(v) === i)
                  for (const key1 in unique) {
                    AttrSetItems.groups.push({
                      id: unique[key1],
                      content: uniqueNames[key1],
                      className: 'lableNone',
                      selected: []
                    })
                  }
                  if (item.attributes !== null) {
                    const attributes = item.attributes.split('~')
                    for (const attr in attributes) {
                      if (attributes[attr] !== '') {
                        const detail = attributes[attr].split(',')
                        let attributeCode = []
                        for (var acode in AttrSetItems.items) {
                          if (AttrSetItems.items[acode].id === detail[0]) {
                            attributeCode = AttrSetItems.items[acode]
                            AttrSetItems.items.splice(acode, 1)
                          }
                        }
                        for (acode in AttrSetItems.groups) {
                          if (AttrSetItems.groups[acode].id === detail[1]) {
                            AttrSetItems.groups[acode].selected.push(attributeCode)
                          }
                        }
                      }
                    }
                  }
                }
              } else {
                Inputs[key] = item[key]
              }
              return true
            })
          )
          for (const key in AttrSetItems.groups) {
            AttrSetItems.groups[key].id = key
          }
          setForceUpdate(!isForceUpdate)
        })
      }
    })
  }

  const GetProductAttributeList = () => {
    const param = {
      limit: 10,
      page: 1
    }
    const ArrayItem = []
    setLoading(true)
    HttpService.postApi(API.GetProductAttributeList, param).then((response) => {
      setLoading(false)
      response.data.result[0].map(function (k, v) {
        ArrayItem.push({ id: k.attribute_code, content: k.attribute_name })
        return true
      })
      AttrSetItems.items = ArrayItem
      setForceUpdate(!isForceUpdate)
    })
  }

  const SubmitGroup = (e) => {
    if (!groupvalidator.current.allValid()) {
      groupvalidator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    // console.log(GroupInputs);
    // return ;
    if (GroupInputs.id === '') {
      const count = AttrSetItems.groups.length
      var index = AttrSetItems.groups.findIndex(
        (item) => item.content.trim().toLowerCase() === GroupInputs.name.trim().toLowerCase()
      )

      if (index > -1) {
        setIsDuplicateGroup(true)
        setShowGroupModal(true)
        setForceUpdate(!isForceUpdate)
        return
      } else {
        setIsDuplicateGroup(false)
        AttrSetItems.groups.push({
          id: count,
          content: GroupInputs.name,
          className: 'lableNone',
          selected: []
        })
        setShowGroupModal(false)
        setForceUpdate(!isForceUpdate)
      }
    } else {
      index = AttrSetItems.groups.findIndex(
        (item) =>
          item.content.trim().toLowerCase() === GroupInputs.name.trim().toLowerCase() &&
          Number(item.id) !== Number(GroupInputs.id)
      )

      if (index > -1) {
        setIsDuplicateGroup(true)
        setForceUpdate(!isForceUpdate)
        return
      } else {
        AttrSetItems.groups[GroupInputs.id].content = GroupInputs.name
        setIsDuplicateGroup(false)
        setShowGroupModal(false)
      }
    }
    GroupInputs.id = 0
    GroupInputs.name = ''
    for (const key in AttrSetItems.groups) {
      AttrSetItems.groups[key].className = 'labelNone'
      setForceUpdate(!isForceUpdate)
    }
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    // console.log('LN 204 SubmitForm');
    // return;

    if (!validator.current.allValid()) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const attributeGroups = AttrSetItems.groups
    let groupString = ''
    for (const key in attributeGroups) {
      if (key > 0) {
        groupString += '^'
      }
      groupString += attributeGroups[key].content
      if (attributeGroups[key].selected.length > 0) {
        groupString += '~'
        const selectedAttributes = attributeGroups[key].selected
        for (const key1 in selectedAttributes) {
          if (key1 > 0) {
            groupString += ','
          }
          groupString += selectedAttributes[key1].id
        }
      }
    }
    const param = {
      id: Inputs.id,
      name: Inputs.name,
      status: Inputs.status,
      attributes: groupString,
      Userid: user.id
    }
    if (urlParams.id === undefined) {
      setLoading(true)
      HttpService.postApi(API.AddProductAttributeSet, param).then((response) => {
        setLoading(false)

        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          return
        }
        toast.success(Messages.RecordAdded)
        setForceUpdate(!isForceUpdate)
        history.push('/attribute/attributeset')
      })
    } else {
      setLoading(true)
      HttpService.postApi(API.UpdateProductAttributeSet, param).then((response) => {
        setLoading(false)
        if (response.data.message) {
          toast.warning(response.data.message)
          setForceUpdate(!isForceUpdate)
          return
        }
        toast.success(Messages.RecordUpdated)
        setForceUpdate(!isForceUpdate)
        history.push('/attribute/attributeset')
      })
    }
  }

  const openAddGroupModal = () => {
    GroupInputs.id = ''
    GroupInputs.name = ''
    groupvalidator.current.hideMessages()
    setGroupModalTitle(Title.AddAttributeGroup)
    setIsDuplicateGroup(false)
    setForceUpdate(!isForceUpdate)
    setShowGroupModal(true)
  }

  const handleDoubleClick = (value) => {
    // console.log('Ln 275 handleDoubleClick');
    GroupInputs.id = ''
    GroupInputs.name = ''

    GroupInputs.id = value.target.attributes.name.value
    GroupInputs.name = value.target.innerText
    setGroupModalTitle(Title.EditAttributeGroup)
    setForceUpdate(!isForceUpdate)
    setShowGroupModal(true)
  }

  const handleGroupSelect = (value) => {
    // console.log('Ln 289 handleGroupSelect')
    GroupInputs.id = value.target.attributes.name.value
    GroupInputs.name = value.target.innerText
    const id = value.target.attributes.name.value
    for (const key in AttrSetItems.groups) {
      AttrSetItems.groups[key].className = 'labelNone'
      setForceUpdate(!isForceUpdate)
    }
    const index = AttrSetItems.groups.findIndex((item) => Number(item.id) === Number(id))
    AttrSetItems.groups[index].className = 'labelGray'
    setIsDuplicateGroup(false)
    setForceUpdate(!isForceUpdate)
  }

  const handleAccordionClick = (e, index) => {
    // var className = e.target.className;
    // var classSplit = className.split(" ");
    // if (classSplit.indexOf("mdi-minus-box") > -1) {
    //     var index = classSplit.indexOf("mdi-minus-box");
    //     classSplit[index] = "mdi-plus-box";
    //     e.target.className = classSplit.join(" ");
    // }
    // else {
    //     var index = classSplit.indexOf("mdi-plus-box");
    //     classSplit[index] = "mdi-minus-box";
    //     e.target.className = classSplit.join(" ");
    // }
    const IsCheckActivelst = document.getElementsByClassName('active').length > 0
    if (IsCheckActivelst) {
      var activelst = document.getElementsByClassName('active')
      for (let index = 0; index <= activelst.length; index++) {
        const element = activelst[index]
        element.classList.remove('active')
      }
    }
    const icons = document.getElementById(index)
    if (e.target.className.includes('mdi-minus-box')) {
      icons.className = defaultPlus
    } else {
      icons.className = defaultminus
      icons.classList.add('active')
    }

    activelst = document.getElementsByClassName('menu-icon')
    for (let index = 0; index < activelst.length; index++) {
      const element = activelst[index].classList
      if (!element.value.includes('active')) element.value = defaultPlus
    }
    setIsDuplicateGroup(false)
  }

  const deleteSelectedGroup = () => {
    if (parseInt(GroupInputs.id) === 0 || GroupInputs.id === '') {
      swal({
        title: Messages.oops,
        text: Messages.defaultgroupnotdelete,
        buttons: {
          cancel: false,
          confirm: true
        }
      })
    } else {
      const id = GroupInputs.id
      // console.log("Elseee Id "+id+' '+AttrSetItems.groups.length);
      if (parseInt(id) === 0 && AttrSetItems.groups.length === 1) {
        swal({
          title: Messages.oops,
          text: Messages.atleastonegroup,
          buttons: {
            cancel: false,
            confirm: true
          }
        })
      } else {
        const index = AttrSetItems.groups.findIndex((item) => Number(item.id) === Number(id))

        const attributes = AttrSetItems.groups[index].selected
        for (const key in attributes) {
          AttrSetItems.items.push(attributes[key])
          setForceUpdate(!isForceUpdate)
        }
        AttrSetItems.groups[index].selected = []
        AttrSetItems.groups.splice(index, 1)
        setForceUpdate(!isForceUpdate)
      }
    }
  }

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)

    return result
  }

  /**
   * Moves an item from one list to another list.
   */
  const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source)
    const destClone = Array.from(destination)
    const [removed] = sourceClone.splice(droppableSource.index, 1)

    destClone.splice(droppableDestination.index, 0, removed)

    const result = {}
    result[droppableSource.droppableId] = sourceClone
    result[droppableDestination.droppableId] = destClone

    return result
  }

  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    ...draggableStyle
  })

  const getListStyle = (isDraggingOver) => ({
    padding: grid
  })

  const getBoxHeight = (id) => ({
    height: '420px',
    overflowY: 'scroll'
  })

  const getAttrListStyle = (isDraggingOver) => ({
    padding: grid,
    height: '500px',
    overflowY: 'scroll',
    fontSize: 14
  })

  const getList = (id) => {
    const hasNumber = /\d/
    if (hasNumber.test(id)) {
      const destindex = id.match(/(\d+)/)
      return AttrSetItems.groups[destindex[0]].selected
    } else {
      return AttrSetItems[id2List[id]]
    }
  }

  const onDragEnd = (result) => {
    const { source, destination } = result
    // dropped outside the list
    if (!destination) {
      return
    }
    const hasNumber = /\d/
    if (hasNumber.test(source.droppableId) && hasNumber.test(destination.droppableId)) {
      const sourindex = source.droppableId.match(/(\d+)/)
      const destindex = destination.droppableId.match(/(\d+)/)
      if (source.droppableId === destination.droppableId) {
        const items = reorder(getList(source.droppableId), source.index, destination.index)
        AttrSetItems.groups[sourindex[0]].selected = items
      } else {
        const result = move(
          getList(source.droppableId),
          getList(destination.droppableId),
          source,
          destination
        )
        var dropId = destination.droppableId
        const dropId1 = source.droppableId
        AttrSetItems.groups[sourindex[0]].selected = result[dropId1]
        AttrSetItems.groups[destindex[0]].selected = result[dropId]
      }
    } else if (hasNumber.test(destination.droppableId)) {
      const destindex = destination.droppableId.match(/(\d+)/)
      // console.log(destination)
      const result = move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination
      )
      const dropId = destination.droppableId
      AttrSetItems.items = result.droppable
      AttrSetItems.groups[destindex[0]].selected = result[dropId]
    } else if (hasNumber.test(source.droppableId)) {
      const sourindex = source.droppableId.match(/(\d+)/)
      const result = move(
        getList(source.droppableId),
        getList(destination.droppableId),
        source,
        destination
      )
      dropId = source.droppableId
      AttrSetItems.items = result.droppable
      AttrSetItems.groups[sourindex[0]].selected = result[dropId]
    } else {
      const items = reorder(getList(source.droppableId), source.index, destination.index)
      AttrSetItems.items = items
    }
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined
            ? Title.EditProductAttributeSet
            : Title.AddProductAttributeSet}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={handleInputChanges}
                        defaultValue={Inputs.name}
                        placeholder="Name"
                      />
                      {validator.current.message('Name', Inputs.name, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername3"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges}
                            id="status"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="status"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <DragDropContext onDragEnd={onDragEnd}>
                    <div className="col-md-6">
                      <div className="form-group d-none">
                        <label>Groups</label>

                        <hr className="m-0"></hr>
                        <div className="row mt-2">
                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-custom text-white mr-2"
                              onClick={openAddGroupModal}
                            >
                              Add New
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary mr-2"
                              onClick={deleteSelectedGroup}
                              disabled={parseInt(GroupInputs.id) === 0 || GroupInputs.id === ''}
                            >
                              Delete Selected Group
                            </button>
                          </div>
                          <div className="col-md-12 mt-1 note">
                            Double click on a group to rename it.
                          </div>
                        </div>
                      </div>
                      <div className="row mt-2">
                        <div
                          className="col-md-12"
                          style={getBoxHeight(1)}
                        >
                          <div id="accordion">
                            {AttrSetItems.groups.map((group, index) => (
                              <div
                                className="card border p-2"
                                key={index}
                              >
                                <div className="card-header p-0 border-none">
                                  <a
                                    className="fs-16 p-0 pr-1 collapsed"
                                    onClick={(event) => handleAccordionClick(event, index)}
                                    data-toggle="collapse"
                                    data-target={'#attr_group' + index}
                                    aria-expanded="true"
                                    aria-controls={'attr_group' + index}
                                  >
                                    <i
                                      id={index}
                                      className={defaultPlus}
                                    ></i>
                                  </a>
                                  <label
                                    name={group.id}
                                    className={group.className}
                                    style={{ margin: 0, padding: '2px' }}
                                    onClick={handleGroupSelect}
                                    onDoubleClick={handleDoubleClick}
                                  >
                                    {group.content}
                                  </label>
                                </div>

                                <div
                                  id={'attr_group' + index}
                                  className="collapse"
                                  aria-labelledby="headingOne"
                                  data-parent="#accordion"
                                >
                                  <div className="card-body p-0 pl-4 font-dark">
                                    <Droppable droppableId={'droppable' + index}>
                                      {(provided, snapshot) => (
                                        <div
                                          ref={provided.innerRef}
                                          style={getListStyle(snapshot.isDraggingOver)}
                                        >
                                          {group.selected.map((item, index) => (
                                            <Draggable
                                              key={item.id}
                                              draggableId={item.id}
                                              index={index}
                                            >
                                              {(provided, snapshot) => (
                                                <div
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}
                                                  style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                                  )}
                                                >
                                                  {item.content + ' - ' + item.id}
                                                </div>
                                              )}
                                            </Draggable>
                                          ))}
                                          {provided.placeholder}
                                        </div>
                                      )}
                                    </Droppable>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Unassigned Attributes</label>

                        <hr className="m-0"></hr>
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              style={getAttrListStyle(snapshot.isDraggingOver)}
                            >
                              {/* {console.log(AttrSetItems)} */}
                              {AttrSetItems.items.map((item, index) => (
                                <Draggable
                                  key={item.id}
                                  draggableId={item.id}
                                  index={index}
                                >
                                  {(provided, snapshot) => (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={getItemStyle(
                                        snapshot.isDragging,
                                        provided.draggableProps.style
                                      )}
                                    >
                                      {item.content + ' - ' + item.id}
                                    </div>
                                  )}
                                </Draggable>
                              ))}
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                      </div>
                    </div>
                  </DragDropContext>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/attribute/attributeset"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Modal
        size="md"
        show={ShowGroupModal}
        onHide={() => setShowGroupModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="edit-address-modal">{GroupModalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label>Group Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  onChange={handleGroupInputChanges}
                  defaultValue={GroupInputs.name}
                  placeholder="Group Name"
                />
                {groupvalidator.current.message('Group Name', GroupInputs.name, 'required', {
                  className: 'error'
                })}
                {IsDuplicateGroup && <label className="error">Group already exist</label>}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={SubmitGroup}
          >
            Submit
          </Button>
          <Button
            variant="light"
            onClick={() => setShowGroupModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export default AddProductAttributeSet
